import { render, staticRenderFns } from "./cart-address-modal.vue?vue&type=template&id=4cd659c4&scoped=true"
import script from "./cart-address-modal.vue?vue&type=script&lang=js"
export * from "./cart-address-modal.vue?vue&type=script&lang=js"
import style0 from "./cart-address-modal.vue?vue&type=style&index=0&id=4cd659c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd659c4",
  null
  
)

export default component.exports